// extracted by mini-css-extract-plugin
module.exports = {"root":"_5Ti9KH0f","scrollableContainer":"zYwNb7Kf","scrollableContainerWithSnap":"_2ckwc2oX","control":"ZyhEIQNC","controlPrev":"_5ICLBnvU","controlNext":"vYoMMmd_"};